import { render, staticRenderFns } from "./EditProductVariants.vue?vue&type=template&id=66ba331e&"
import script from "./EditProductVariants.vue?vue&type=script&lang=js&"
export * from "./EditProductVariants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports